var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2021 SICK AG
 */
import { classMap, Component, CustomElement, html, Prop } from '@sick-davinci/ce-decorators';
import { style } from './HeaderButton.style';
import { icon_search } from '@sick-davinci/material-icons/action/search.icon';
import { icon_info } from '@sick-davinci/material-icons/action/info.icon';
import { icon_language } from '@sick-davinci/material-icons/action/language.icon';
import { icon_apps } from '@sick-davinci/material-icons/navigation/apps.icon';
import { icon_person } from '@sick-davinci/material-icons/social/person.icon';
import { icon_menu } from '@sick-davinci/material-icons/navigation/menu.icon';
/**
 * Available standard-buttons
 * Use "keyof StandardButtons" for typing: const myKey: keyof StandardButtons = 'apps'
 */

export
/**
 * The `davinci-core-header-button` generates a button for the davinci-core-header2
 *
 * @example
 * ```html
 * <davinci-core-header-button standard="about"></davinci-core-header-button>
 * <davinci-core-header-button icon-src="[SVG-STRING]"></davinci-core-header-button>
 * ```
 */
let HeaderButton = (_dec = Component({
  style: [style],
  tag: 'davinci-core-header-button',
  dependencies: []
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", String), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", String), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", Boolean), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", Boolean), _dec(_class = (_class2 = class HeaderButton extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "icon", _descriptor, this);

    _initializerDefineProperty(this, "title", _descriptor2, this);

    _initializerDefineProperty(this, "active", _descriptor3, this);

    _initializerDefineProperty(this, "disabled", _descriptor4, this);

    this.standardIcons = {
      about: icon_info,
      apps: icon_apps,
      language: icon_language,
      navigation: icon_menu,
      search: icon_search,
      user: icon_person
    };
  }

  componentConnected() {
    this.addEventListener('click', e => {
      if (this.disabled) {
        e.stopImmediatePropagation();
      }
    });
  }

  render() {
    const classes = classMap({
      disabled: this.disabled
    });
    return html`
      <davinci-icon-ref
        .src="${this._getIcon()}"
        class="${classes}"
        title="${this.title}"
      ></davinci-icon-ref>
    `;
  }

  _getIcon() {
    return this.standardIcons[this.icon] || this.icon;
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "icon", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "title", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "active", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
})), _class2)) || _class);
